import { render, staticRenderFns } from "./workRecordLastItemsBox.vue?vue&type=template&id=5fc00a9b&"
import script from "./workRecordLastItemsBox.vue?vue&type=script&lang=ts&"
export * from "./workRecordLastItemsBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports